export default {
  header: {
    fontFamily: "inherit",
    backgroundColor: "#000000",
    textColor: "#FFFFFF",
    fontSize: "15px",
    borderRadius: "16px",
  },
  notification: {
    default: {
      fontSize: "14px",
      borderRadius: "14px",
      margin: "6px",
      backgroundColor: "#FFFFFF",
      textColor: "#252525",
      fontFamily: "inherit",
      hover: { backgroundColor: "#DEDFE0" },
    },
    unread: {
      backgroundColor: "#F1F3F4",
      textColor: "#252525",
      hover: { backgroundColor: "#DEDFE0" },
      state: { color: "#252525" },
    },
    unseen: {
      backgroundColor: "#F1F3F4",
      textColor: "#252525",
      hover: { backgroundColor: "#DEDFE0" },
      state: { color: "#252525" },
    },
  },
  icon: { borderColor: "#FFFFFF", width: "24px" },
  unseenBadge: { backgroundColor: "#F80808" },
};
